import { FC } from 'react';
import { Button } from '../../../../../components-v2/Button';
import { MailSparkleIcon } from '../../../../svgs/icons/MailSparkleIcon';
import { AgentRow, AgentRowIcon } from '../../AgentRow';

export const DashboardInboxAssistantErrorRow: FC<{ onRetry: () => void }> = ({ onRetry }) => (
	<AgentRow
		icon={
			<AgentRowIcon>
				<MailSparkleIcon />
			</AgentRowIcon>
		}
		title='Inbox Assistant'
		detail='We couldn’t load your latest brief.'
		action={
			<Button size='sm' variant='secondary' onClick={onRetry}>
				Try again
			</Button>
		}
	/>
);
